(() => {
  'use strict';
  const selector = '[data-pm-collection-picker]';
  const desktop = window.matchMedia('(min-width:860px) and (hover:hover), (min-width:1025px)');
  let current = null;
  let queued = false;

  function synchronize() {
    queued = false;
    document.querySelectorAll(selector).forEach(picker => {
      const native = picker.querySelector('select');
      const options = [...picker.querySelectorAll('[data-pm-collection-option]')];
      const selected = options.find(option => option.dataset.pmCollectionOption === native.value);
      options.forEach(option => option.setAttribute('aria-selected', String(option === selected)));
      if (!selected) return;
      const value = picker.querySelector('[data-pm-picker-value]');
      if (value.textContent !== selected.dataset.label) value.textContent = selected.dataset.label;
      const trigger = picker.querySelector('.pm-kit-picker__trigger');
      trigger.setAttribute('aria-label', picker.querySelector('.pm-kit-picker__label').textContent + ': ' + selected.dataset.label);
      trigger.title = selected.dataset.label;
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(synchronize);
  }

  function close(restoreFocus = false) {
    if (!current) return;
    const picker = current;
    picker.querySelector('.pm-kit-picker__menu').hidden = true;
    picker.querySelector('.pm-kit-picker__trigger').setAttribute('aria-expanded', 'false');
    current = null;
    if (restoreFocus) picker.querySelector('.pm-kit-picker__trigger').focus({preventScroll:true});
  }

  function open(picker, focusOption = false) {
    close();
    synchronize();
    current = picker;
    picker.querySelector('.pm-kit-picker__menu').hidden = false;
    picker.querySelector('.pm-kit-picker__trigger').setAttribute('aria-expanded', 'true');
    if (focusOption) (picker.querySelector('[aria-selected="true"]') || picker.querySelector('[role="option"]'))?.focus({preventScroll:true});
  }

  document.addEventListener('click', event => {
    const picker = event.target.closest?.(selector);
    if (!picker || !desktop.matches) return;
    const trigger = event.target.closest('.pm-kit-picker__trigger');
    if (trigger) {
      if (current === picker) close(); else open(picker, event.detail === 0);
      return;
    }
    const option = event.target.closest('[data-pm-collection-option]');
    if (!option) return;
    close(true);
    const native = picker.querySelector('select');
    if (native.value === option.dataset.pmCollectionOption) return;
    native.value = option.dataset.pmCollectionOption;
    synchronize();
    native.dispatchEvent(new Event('change', {bubbles:true}));
  });

  document.addEventListener('keydown', event => {
    const picker = event.target.closest?.(selector);
    if (!picker || !desktop.matches) return;
    const trigger = event.target.closest('.pm-kit-picker__trigger');
    if (trigger && ['ArrowDown','ArrowUp'].includes(event.key)) {
      event.preventDefault(); open(picker, true); return;
    }
    if (!current) return;
    if (event.key === 'Escape') { event.preventDefault(); close(true); return; }
    if (event.key === 'Tab') { close(); return; }
    const option = event.target.closest('[role="option"]');
    if (!option || !['ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const options = [...current.querySelectorAll('[role="option"]:not(:disabled)')];
    const index = options.indexOf(option);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
    options[next]?.focus({preventScroll:true});
  });

  document.addEventListener('pointerdown', event => { if (current && !current.contains(event.target)) close(); });
  document.addEventListener('focusin', event => { if (current && !current.contains(event.target)) close(); });
  document.addEventListener('change', event => { if (event.target.matches?.(selector + ' select')) schedule(); }, true);
  window.addEventListener('popstate', () => { close(); schedule(); });
  desktop.addEventListener('change', () => close());
  function boot() {
    synchronize();
    const main = document.querySelector('#site-main');
    if (main) new MutationObserver(schedule).observe(main, {childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
})();
